export const filterSchema = ($http: HttpApi) => ({
  create: (viewId: string, { operation, viewFilterType, fieldId }) => $http.$post(`/builder/views/${viewId}/filter_schema`, {
    body: {
      operation,
      view_filter_type: viewFilterType,
      field_id: fieldId,
    },
  }),
});
